import * as React from 'react';
import { IconButton } from '../../components';
import { Remove } from '../../icons';
import { useCharts } from '../components/Charts';
import * as Pin from './Pinned.styles';
import * as Item from './components/DetailItem.styles';
import { palette } from '../../constants';
import { defaultMargins, toFixed } from '../utils';
import { scaleTime } from '@visx/scale';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
export function Pinned(_a) {
    var xDomain = _a.xDomain, marginsProp = _a.margins, timezone = _a.timezone;
    var _b = useCharts(), pinned = _b.pinned, clearPointXY = _b.clearPointXY, pointXY = _b.pointXY, width = _b.width;
    var margins = defaultMargins(marginsProp);
    var xScale = React.useMemo(function () {
        if (xDomain === undefined || pointXY === undefined)
            return;
        return scaleTime({
            domain: xDomain,
            range: [0, width - margins.left - margins.right]
        });
    }, [xDomain, width, margins]);
    // Close the panel if the time range changes
    React.useEffect(function () {
        clearPointXY();
    }, [xDomain]);
    if (pinned === undefined || pointXY === undefined || pinned.size === 0)
        return null;
    var mouseDate = xScale === null || xScale === void 0 ? void 0 : xScale.invert(pointXY.x);
    var time = timezone !== undefined && mouseDate !== undefined
        ? utcToZonedTime(mouseDate, timezone)
        : mouseDate;
    return (React.createElement(Pin.Container, null,
        React.createElement(Pin.Head, null,
            time !== undefined ? (React.createElement(Pin.Time, null, format(time, 'HH:mm E, MMM do'))) : (React.createElement("span", null)),
            React.createElement(IconButton, { tiny: true, onClick: clearPointXY, icon: React.createElement(Remove, { tiny: true }) })),
        React.createElement(Pin.Body, null, Array.from(pinned.entries()).map(function (_a) {
            var id = _a[0], chart = _a[1];
            return (React.createElement(Pin.Section, { key: id },
                React.createElement(Pin.SectionTitle, null, id),
                chart.data.map(function (d) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    // If there's no data for the clicked point, exit early
                    if (d.datum === undefined)
                        return null;
                    var accessors = chart.accessors;
                    var name = accessors.name(d.series);
                    var key = accessors.key(d.series);
                    var y = accessors.y(d.datum);
                    var unit = (_b = (_a = accessors === null || accessors === void 0 ? void 0 : accessors.unitSymbol) === null || _a === void 0 ? void 0 : _a.call(accessors, d.series)) !== null && _b !== void 0 ? _b : '';
                    var group = (_c = accessors === null || accessors === void 0 ? void 0 : accessors.group) === null || _c === void 0 ? void 0 : _c.call(accessors, d.series);
                    var groupName = (_d = accessors === null || accessors === void 0 ? void 0 : accessors.group) === null || _d === void 0 ? void 0 : _d.call(accessors, d.series);
                    var type = (_e = accessors === null || accessors === void 0 ? void 0 : accessors.type) === null || _e === void 0 ? void 0 : _e.call(accessors, d.series);
                    var color = (_g = (_f = chart === null || chart === void 0 ? void 0 : chart.colorScheme) === null || _f === void 0 ? void 0 : _f.call(chart, key)) !== null && _g !== void 0 ? _g : palette.blue5;
                    return (React.createElement(Item.Item, { key: key, title: groupName !== undefined ? name + " - " + groupName : name, hasGroupName: groupName !== undefined, color: color, isActive: type === 'boolean' ? Boolean(accessors.y(d.datum)) : true },
                        React.createElement(Item.LabelContainer, null,
                            React.createElement(Item.Label, null, name),
                            group !== undefined && (React.createElement(Item.SubLabel, null, group))),
                        React.createElement(Item.ItemValue, null,
                            type === 'number' || type === 'time'
                                ? toFixed(y, 2) + " " + unit
                                : null,
                            type === 'boolean' && y > 0 ? 'true' : null,
                            type !== 'boolean' &&
                                type !== 'number' &&
                                type !== 'time'
                                ? typeof y === 'number'
                                    ? toFixed(y, 2)
                                    : null
                                : null)));
                })));
        }))));
}
//# sourceMappingURL=Pinned.js.map